import AttachmentService from "../../attachments/AttachmentService";
import http from './../../../core/services/http.service';
import {AppSettings} from "@/shared/AppSettings";

export default {
  namespaced: true,
  state: {
    object_uuid: null,
    object_name: null,
    attachment_type: null,
    loading: false,
    tableData: {
      rows: [],
    },
    viewModal: {
      show: false,
      file: null
    }
  },
  actions: {
    setData({commit}, payload) {
      return commit('setData', payload);
    },
    getAttachment({commit, state}, uuid) {
      return http.get(`/api/v1/${state.plural_object_name}/attachments/${uuid}/?expand=created_by`);
    },
    async getAttachments({commit, state}) {
      commit('toggleAttachmentsLoader', true);
      let url = `/api/v1/${state.plural_object_name}/${state.object_uuid}/attachments/?expand=created_by`;
      if (state.attachment_type) {
        url += `&type=${state.attachment_type}`;
      }
      let response = await http.get(url);
      commit('toggleAttachmentsLoader', false);
      if (response.success) {
        commit('updateAttachments', response.body)
      }
      return response.body;
    },
    async createAttachments({state}, {formData, onUploadProgress}) {
      let response = await AttachmentService.createAttachments(formData, onUploadProgress, state.plural_object_name)
      if (response.success) {
        response.body.forEach(item => state.tableData.rows.unshift(item));
        state.tableData.rows = [...state.tableData.rows]
      }
      return response;
    },
    async deleteAttachment({state}, payload) {
      let response = await AttachmentService.deleteAttachment(payload, state.plural_object_name)
      if (response.success) {
        state.tableData.rows = state.tableData.rows.filter(item => item.uuid !== payload);
      }
      return response;
    },
    showViewModal({commit}, payload) {
      commit('showViewModal', payload);
    },
    hideViewModal({commit}) {
      commit('hideViewModal');
    },
    updateViewModalFile({commit}, file) {
      commit('updateViewModalFile', file);
    },
    updateFileInList({commit}, file) {
      commit('updateFileInList', file);
    }
  },
  mutations: {
    updateAttachments: (state, data) => state.tableData.rows = data,
    toggleAttachmentsLoader: (state, data) => state.loading = data,
    setData: (state, {object_uuid, object_name, plural_object_name, attachment_type}) => {
      state.object_uuid = object_uuid;
      state.object_name = object_name;
      state.plural_object_name = plural_object_name;
      state.attachment_type = attachment_type;
    },
    showViewModal(state, file) {
      state.viewModal.show = true;
      state.viewModal.file = file;
    },
    hideViewModal(state) {
      state.viewModal.show = false;
      state.viewModal.file = null;
    },
    updateViewModalFile(state, file) {
      state.viewModal.file = {...state.viewModal.file, ...file};
    },
    updateFileInList(state, file) {
      let index = state.tableData.rows.findIndex(f => f.uuid === file.uuid);
      state.tableData.rows[index] = {...state.tableData.rows[index], ...file};
      state.tableData.rows = [...state.tableData.rows];
    }
  }
}
